module.exports = __webpack_public_path__ + "img/messageImage_02.jpg";